import { call } from '../../../utils/serviceUtils';
import {
  COMPANY_MAIL_ADDRESS_GET,
  COMPANY_MAIL_ADDRESS
  } from '../../../config/paths';

export function getAllMailAddress() {
  return call.get(COMPANY_MAIL_ADDRESS_GET,
    {

    });
}

export function deleteMailAddress(id) {
  return call.delete(COMPANY_MAIL_ADDRESS + '/' + id,
  {
    
  });
}

export function createMailAddress(data) {
  return call.post(COMPANY_MAIL_ADDRESS, data);
}

export function updateMailAddress(id,data) {
  return call.put(COMPANY_MAIL_ADDRESS + '/' + id, data);
}


